import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
import { SocoConfigurationService } from '@soco/configuration';
// DSS Documentation on ApiResult - http://tiny.sc/cgapiresult
import { ApiResult } from '@soco/core';

@Injectable({
    providedIn: 'root'
})
export class WebApiConfigService {
    private openModalSource = new Subject();
    private closeModalSource = new Subject();

    openModal$ = this.openModalSource.asObservable();
    closeModal$ = this.closeModalSource.asObservable();
    public webApiBaseUrl: String;
    public webApiToken: String;

    constructor(
        private config: SocoConfigurationService
    ) { }

    setConfigWebApiInfo() {
        if (window.location.hostname === 'dv-kmi.southernco.com') {
             this.webApiBaseUrl = 'https://dv-kmi.southernco.com/webservices/api';
             this.webApiToken = 'ANONYMOUS';
             this.config.coolSecurityToken = 'ANONYMOUS';

        } else if (window.location.hostname === 'ua-kmi.southernco.com') {
            this.webApiBaseUrl = 'https://ua-kmi.southernco.com/webservices/api';
            this.webApiToken = 'ANONYMOUS';
            this.config.coolSecurityToken = 'ANONYMOUS';

        } else if (window.location.hostname === 'kmi.southernco.com') {
            this.webApiBaseUrl = 'https://kmi.southernco.com/webservices/api';
            this.webApiToken = 'ANONYMOUS';
            this.config.coolSecurityToken = 'ANONYMOUS';

        } else if (window.location.hostname === 'qa-kmi.southernco.com') {
            this.webApiBaseUrl = 'https://qa-kmi.southernco.com/webservices/api';
            this.webApiToken = 'ANONYMOUS';
            this.config.coolSecurityToken = 'ANONYMOUS';

        } else {
             //this.webApiBaseUrl = 'https://ua-kmi.southernco.com/webservices/api';
            this.webApiBaseUrl = 'https://localhost:44339/api';
             this.webApiToken = 'ANONYMOUS';
             this.config.coolSecurityToken = 'ANONYMOUS';
        }

        if (this.webApiBaseUrl && this.webApiToken) {
            this.config.setSetting('webApiBaseUrl', this.webApiBaseUrl);
            this.config.setSetting('webApiToken', this.webApiToken);
        }

    }

    openModal(result: ApiResult<any>): void {
        // Token has expired if 401, so remove sessionStorage entries
        if (result.statusCode === 401) {
            sessionStorage.removeItem('webApiToken');
        }

        this.openModalSource.next();
    }
}

